import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {VerticalMenuItem} from '../../models/vertical-menu.model';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'si-documentation-page',
  templateUrl: './documentation-page.component.html',
  styleUrls: ['./documentation-page.component.scss']
})
export class DocumentationPageComponent implements OnInit {
  @ViewChild('documentationPageContent') documentationPageContent: ElementRef;
  items: VerticalMenuItem[];

  constructor(
    private translateService: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.setItems();
  }

  async setItems(): Promise<void> {
    const accordionText = this.translateService.instant('CORE_ACCORDION');
    const fieldsText = this.translateService.instant('CORE_FIELDS');
    const orgChartText = this.translateService.instant('CORE_ORG_CHART');
    const tablesText = this.translateService.instant('CORE_TABLES');

    this.items = [
      {
        label: accordionText,
        routerLink: '/core/documentation/accordion'
      },
      {
        label: fieldsText,
        routerLink: '/core/documentation/fields'
      },
      {
        label: orgChartText,
        routerLink: '/core/documentation/org-chart'
      },
      {
        label: tablesText,
        routerLink: '/core/documentation/table'
      }
    ];
  }

  onActivateRouterOutlet(event: Event): void {
    if (!this.documentationPageContent) {
      return;
    }

    this.documentationPageContent.nativeElement.scrollTo(0, 0);
  }
}
